import { render, staticRenderFns } from "./RareStandardButton.vue?vue&type=template&id=2703c558&scoped=true&lang=html"
import script from "./RareStandardButton.vue?vue&type=script&lang=js"
export * from "./RareStandardButton.vue?vue&type=script&lang=js"
import style0 from "./RareStandardButton.vue?vue&type=style&index=0&id=2703c558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703c558",
  null
  
)

export default component.exports